import { useEffect } from 'react'
import ApiService from '../services/ApiService'

const HOTJAR_SCRIPT_SRC = 'https://t.contentsquare.net/uxa/54a65f5ad2682.js'

export default function Hotjar() {
  useEffect(() => {
    const initializeHotjar = async () => {
      try {
        const res = await ApiService.get('/settings')
        if (res.environment !== 'production') return
        if (document.querySelector(`script[src="${HOTJAR_SCRIPT_SRC}"]`)) return

        const script = document.createElement('script')
        script.async = true
        script.src = HOTJAR_SCRIPT_SRC

        script.onerror = () => {
          console.error('Failed to load Hotjar script.')
        }

        document.head.appendChild(script)
      } catch (error) {
        console.error('Failed to fetch settings for Hotjar:', error)
      }
    }

    initializeHotjar()
  }, [])

  return null
}
